module.exports = __webpack_public_path__ + "static/media/premium-block.032c9738.png";